import { render, staticRenderFns } from "./Material_handling.vue?vue&type=template&id=311b4e37"
import script from "./Material_handling.vue?vue&type=script&lang=js"
export * from "./Material_handling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports